module.exports = __webpack_public_path__ + "static/media/subscriber_Mall.1c24faf1.svg";